import ChipOutlined from "./ChipOutlined";
export default ChipOutlined;
